import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';

@AcDialog({
  width: 400
})
@Component({
  selector: 'short-calls-profiles-dialog',
  templateUrl: './short-calls-profiles-dialog.component.html',
  styleUrls: ['./short-calls-profiles-dialog.component.scss'],
})
export class ShortCallsProfilesDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('shortCallsProfileDialog') shortCallsProfileDialog: NgForm;
  shortCallsProfile: any;

  // Do not give an initial default here so we use the values from the profile.
  enableRoutingAction = false;
  // This will be set based on the profile. No explicit default assignment here.
  routingAction: 'LOCKED_FOR_OUTGOING' | 'DROP_OUTGOING';

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig: any) {
    // The dialogData is passed in when opening the dialog.
    this.shortCallsProfile = dialogConfig.dialogData;
    // Ensure the submit button is initially disabled until the form is valid.
    this.dialogConfig.submitButtonDisabled = true;


    if (this.shortCallsProfile.lockedForOutgoingCalls) {
      this.enableRoutingAction = true;
      this.routingAction = 'LOCKED_FOR_OUTGOING';
    } else if (this.shortCallsProfile.dropOutgoingCalls) {
      this.enableRoutingAction = true;
      this.routingAction = 'DROP_OUTGOING';
    } else {
      this.enableRoutingAction = false;
      // If no action is defined, you may choose a default even if the toggle is off.
      this.routingAction = 'LOCKED_FOR_OUTGOING';
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.shortCallsProfileDialog.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.shortCallsProfileDialog.form.valid;
    });
  }

  onRoutingToggleChange(event: MatSlideToggleChange): void {
    this.enableRoutingAction = event.checked;
    if (event.checked) {
      // When enabled, ensure one option is selected (LOCKED_FOR_OUTGOING default).
      if (this.routingAction === 'LOCKED_FOR_OUTGOING') {
        this.shortCallsProfile.lockedForOutgoingCalls = true;
        this.shortCallsProfile.dropOutgoingCalls = false;
      }
      // in case that drop was chosen and than toggle disabled and then toggle enabled again
      else if (this.routingAction === 'DROP_OUTGOING') {
        this.shortCallsProfile.lockedForOutgoingCalls = false;
        this.shortCallsProfile.dropOutgoingCalls = true;
      }
    } else {
      this.shortCallsProfile.lockedForOutgoingCalls = false;
      this.shortCallsProfile.dropOutgoingCalls = false;
    }
  }

  onRoutingActionChange(event: any): void {
    if (event.value === 'LOCKED_FOR_OUTGOING') {
      this.shortCallsProfile.lockedForOutgoingCalls = true;
      this.shortCallsProfile.dropOutgoingCalls = false;
    } else if (event.value === 'DROP_OUTGOING') {
      this.shortCallsProfile.lockedForOutgoingCalls = false;
      this.shortCallsProfile.dropOutgoingCalls = true;
    }
  }
}
